/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_External_Booking_Edit_Admin_Comments_PlaceholderInputs */

const en_admin_external_booking_edit_admin_comments_placeholder = /** @type {(inputs: Admin_External_Booking_Edit_Admin_Comments_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notes for your team — never shared with the visitor.`)
};

/** @type {(inputs: Admin_External_Booking_Edit_Admin_Comments_PlaceholderInputs) => LocalizedString} */
const de_admin_external_booking_edit_admin_comments_placeholder = en_admin_external_booking_edit_admin_comments_placeholder;

/** @type {(inputs: Admin_External_Booking_Edit_Admin_Comments_PlaceholderInputs) => LocalizedString} */
const es_admin_external_booking_edit_admin_comments_placeholder = en_admin_external_booking_edit_admin_comments_placeholder;

/** @type {(inputs: Admin_External_Booking_Edit_Admin_Comments_PlaceholderInputs) => LocalizedString} */
const fr_admin_external_booking_edit_admin_comments_placeholder = en_admin_external_booking_edit_admin_comments_placeholder;

/** @type {(inputs: Admin_External_Booking_Edit_Admin_Comments_PlaceholderInputs) => LocalizedString} */
const it_admin_external_booking_edit_admin_comments_placeholder = en_admin_external_booking_edit_admin_comments_placeholder;

/** @type {(inputs: Admin_External_Booking_Edit_Admin_Comments_PlaceholderInputs) => LocalizedString} */
const pt_br2_admin_external_booking_edit_admin_comments_placeholder = en_admin_external_booking_edit_admin_comments_placeholder;

/** @type {(inputs: Admin_External_Booking_Edit_Admin_Comments_PlaceholderInputs) => LocalizedString} */
const pl_admin_external_booking_edit_admin_comments_placeholder = en_admin_external_booking_edit_admin_comments_placeholder;

/** @type {(inputs: Admin_External_Booking_Edit_Admin_Comments_PlaceholderInputs) => LocalizedString} */
const hu_admin_external_booking_edit_admin_comments_placeholder = en_admin_external_booking_edit_admin_comments_placeholder;

/** @type {(inputs: Admin_External_Booking_Edit_Admin_Comments_PlaceholderInputs) => LocalizedString} */
const ro_admin_external_booking_edit_admin_comments_placeholder = en_admin_external_booking_edit_admin_comments_placeholder;

/**
* | output |
* | --- |
* | "Notes for your team — never shared with the visitor." |
*
* @param {Admin_External_Booking_Edit_Admin_Comments_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_external_booking_edit_admin_comments_placeholder = /** @type {((inputs?: Admin_External_Booking_Edit_Admin_Comments_PlaceholderInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_External_Booking_Edit_Admin_Comments_PlaceholderInputs, { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_external_booking_edit_admin_comments_placeholder(inputs)
	if (locale === "de") return de_admin_external_booking_edit_admin_comments_placeholder(inputs)
	if (locale === "es") return es_admin_external_booking_edit_admin_comments_placeholder(inputs)
	if (locale === "fr") return fr_admin_external_booking_edit_admin_comments_placeholder(inputs)
	if (locale === "it") return it_admin_external_booking_edit_admin_comments_placeholder(inputs)
	if (locale === "pt-BR") return pt_br2_admin_external_booking_edit_admin_comments_placeholder(inputs)
	if (locale === "pl") return pl_admin_external_booking_edit_admin_comments_placeholder(inputs)
	if (locale === "hu") return hu_admin_external_booking_edit_admin_comments_placeholder(inputs)
	return ro_admin_external_booking_edit_admin_comments_placeholder(inputs)
});
export { admin_external_booking_edit_admin_comments_placeholder as "admin.external_booking_edit.admin_comments_placeholder" }